// extracted by mini-css-extract-plugin
var _1 = "_buyOrSellGoldSummary-module__button-container";
var _2 = "_buyOrSellGoldSummary-module__container";
var _3 = "_buyOrSellGoldSummary-module__product-container";
var _4 = "_buyOrSellGoldSummary-module__show-serial-no";
var _5 = "_buyOrSellGoldSummary-module__summary-table";
export { _1 as "button-container", _2 as "container", _3 as "product-container", _4 as "show-serial-no", _5 as "summary-table" }
